module.exports = __webpack_public_path__ + "static/img/tts_ads.6aaf0650.png";